export const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About Us' },
  { path: '/products', label: 'Products' },
  { path: '/partners', label: 'Partners' },
  { path: '/team', label: 'Our Team' },
  { path: '/contact', label: 'Contact Us' },
];
